import { TableCell, TableHead, TableRow, useTheme } from '@mui/material';

export default function ListHead({ headLabel }) {
  const theme = useTheme();

  return (
    <TableHead sx={{ backgroundColor: theme.palette.grey[200] }}>
      <TableRow>
        {headLabel.map((headCell) => (
          <TableCell
            key={headCell.id}
            align="center"
            sx={{
              textTransform: 'uppercase',
              fontWeight: 'bold',
              fontSize: '14px',
              width: headCell.id === 'name' ? '20%' : 'auto',
              padding: '16px 16px',
            }}>
            {headCell.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
